<script lang="ts" setup>
import PackingSlipTable from "@/data-views/tables/packing_slip/PackingSlipTable.vue";
definePage({
  meta: {
    action: "read",
    subject: "PackingSlip",
    doNotActivate: true,
    navActiveLink: "packing-slip-new",
  },
});

const loading = ref(false);

onMounted(() => {
  loading.value = true;
  setTimeout(() => {
    loading.value = false;
  }, 500);
});
</script>

<template>
  <VRow class="match-height">
    <VCol cols="12">
      <PackingSlipTable v-if="!loading" />
      <div v-else style="min-height: 50vh" />
    </VCol>
  </VRow>
</template>
